import {
  PersonHolderFormData,
  UserRegistrationFormData,
} from 'app/pages/UserRegistration/UserRegistrationForm/formTypes'
import { axiosInstance } from 'app/utils/axiosConfig'
import { User } from 'EstraSponsor'

import { endpoints } from './endpoints'

export type GetUserResponse = User

export const getUser = async (): Promise<GetUserResponse | null> => {
  return axiosInstance.get(endpoints.user.getUser).then(({ data }) => data)
}

export type UpdateUserPayload = Partial<
  Omit<
    UserRegistrationFormData,
    | 'company_cciaa_date'
    | 'company_date_start'
    | 'holder_address'
    | 'technical_director_address'
    | 'technical_manager_address'
  > & {
    company_cciaa_date: Maybe<string>
    company_date_start: Maybe<string>
    holder_address: Omit<PersonHolderFormData, 'birth_date'> & {
      birth_date: Maybe<string>
    }
    technical_director_address: Omit<PersonHolderFormData, 'birth_date'> & {
      birth_date: Maybe<string>
    }
    technical_manager_address: Omit<PersonHolderFormData, 'birth_date'> & {
      birth_date: Maybe<string>
    }
  }
>
export type UpdateUserResponse = User

export const updateUser = async (
  data: UpdateUserPayload
): Promise<UpdateUserResponse> => {
  return axiosInstance
    .put(endpoints.user.updateUser, data)
    .then(({ data }) => data)
}

// Used as refernce for FormData
export type UploadFileUserPayload = {
  file: FileList
  type: 'identity_document' | 'pdf_registry'
}

export type UploadFileUserResponse =
  | {
      pdf_registry_url: string
    }
  | {
      identity_document_url: string
    }

export const uploadFileUser = async (
  data: FormData
): Promise<UploadFileUserResponse> => {
  return axiosInstance.put(endpoints.user.upload, data).then(({ data }) => data)
}

export const getRegistryFileUser = async (): Promise<File | null> => {
  return axiosInstance
    .get(endpoints.user.getRegistryFile, {
      responseType: 'blob',
    })
    .then(({ data }) => data)
}

export type UpdateUserEmailPayload = {
  email: string
}

export const updateUserEmail = async (
  data: UpdateUserEmailPayload
): Promise<void> => {
  return axiosInstance
    .put(endpoints.user.updateUserEmail, data)
    .then(({ data }) => data)
}
